import React, { createContext, useContext, useState, useEffect } from 'react';

const ActiveCourseContext = createContext();

export const useActiveCourse = () => {
    const context = useContext(ActiveCourseContext);
    if (!context) {
        throw new Error('useActiveCourse must be used within ActiveCourseProvider');
    }
    return context;
};

export const ActiveCourseProvider = ({ children }) => {
    const [activeCourseId, setActiveCourseId] = useState(null);
    const [activeCourseData, setActiveCourseData] = useState(null);

    // Initialize from sessionStorage on mount
    useEffect(() => {
        const savedCourseId = sessionStorage.getItem('activeCourse');
        const savedCourseData = sessionStorage.getItem('activeCourseData');

        if (savedCourseId) {
            setActiveCourseId(savedCourseId);
        }

        if (savedCourseData) {
            try {
                setActiveCourseData(JSON.parse(savedCourseData));
            } catch (error) {
                console.error('Error parsing saved course data:', error);
            }
        }
    }, []);

    // Set active course with both ID and full course data
    const setActiveCourse = (courseId, courseData = null) => {
        setActiveCourseId(courseId);
        setActiveCourseData(courseData);

        // Persist to sessionStorage
        sessionStorage.setItem('activeCourse', courseId);
        if (courseData) {
            sessionStorage.setItem('activeCourseData', JSON.stringify(courseData));
        }
    };

    // Clear active course
    const clearActiveCourse = () => {
        setActiveCourseId(null);
        setActiveCourseData(null);
        sessionStorage.removeItem('activeCourse');
        sessionStorage.removeItem('activeCourseData');
    };

    // Validate and clear if invalid
    const validateAndClearIfInvalid = (validCourseIds) => {
        if (activeCourseId && !validCourseIds.includes(activeCourseId)) {
            clearActiveCourse();
            return false; // Was invalid
        }
        return true; // Is valid or not set
    };

    const value = {
        activeCourseId,
        activeCourseData,
        setActiveCourse,
        clearActiveCourse,
        validateAndClearIfInvalid,
    };

    return (
        <ActiveCourseContext.Provider value={value}>
            {children}
        </ActiveCourseContext.Provider>
    );
};
